try {
    window.bootstrap = require("bootstrap");
    window.$ = require("jquery");
    window.axios = require("axios");
    window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
} catch (e) {
    console.error(e);
}
